import { render, staticRenderFns } from "./ErrorFatalError.vue?vue&type=template&id=99597262&"
import script from "./ErrorFatalError.vue?vue&type=script&lang=js&"
export * from "./ErrorFatalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports